import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  appContainer: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
  sidebar: {
    width: 240,
    backgroundColor: '#1a1a2e',
    paddingTop: 40,
    minHeight: '100vh',
  },
  sidebarHeader: {
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#2a2a4e',
    alignItems: 'center',
  },
  logoImage: {
    width: 180,
    height: 90,
    marginBottom: 12,
    resizeMode: 'contain',
  },
  sidebarLogo: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#fff',
    textAlign: 'center',
  },
  sidebarNav: {
    flex: 1,
    paddingTop: 20,
  },
  navItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 20,
    marginHorizontal: 8,
    borderRadius: 8,
  },
  navItemActive: {
    backgroundColor: '#16213e',
  },
  navIcon: {
    fontSize: 18,
    marginRight: 12,
    width: 24,
    textAlign: 'center',
  },
  navLabel: {
    fontSize: 14,
    color: '#aaa',
  },
  navLabelActive: {
    color: '#fff',
    fontWeight: '600',
  },
  sidebarFooter: {
    padding: 20,
    borderTopWidth: 1,
    borderBottomColor: '#2a2a4e',
  },
  footerText: {
    color: '#666',
    fontSize: 12,
  },
  mainContent: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  contentContainer: {
    flex: 1,
    padding: 24,
  },
  contentTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  contentDate: {
    fontSize: 14,
    color: '#666',
    marginBottom: 24,
  },
  weekRow: {
    flexDirection: 'row',
    marginBottom: 20,
  },
  weekDay: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 12,
    marginHorizontal: 4,
    backgroundColor: '#fff',
    borderRadius: 8,
  },
  weekDayToday: {
    backgroundColor: '#1a1a2e',
  },
  weekDayName: {
    fontSize: 12,
    color: '#666',
    marginBottom: 4,
  },
  weekDayNumber: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
  },
  weekDayNumberToday: {
    color: '#fff',
  },
  calendarGrid: {
    flex: 1,
  },
  calendarRow: {
    flexDirection: 'row',
    minHeight: 60,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  calendarTime: {
    width: 70,
    fontSize: 12,
    color: '#888',
    paddingTop: 8,
  },
  appointmentEmpty: {
    flex: 1,
  },
  appointmentsContainer: {
    flex: 1,
  },
  appointmentCard: {
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 10,
    marginBottom: 8,
    borderLeftWidth: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  appointmentCardPast: {
    opacity: 0.5,
    backgroundColor: '#f5f5f5',
  },
  appointmentTimePast: {
    color: '#999',
  },
  appointmentPatientPast: {
    color: '#999',
  },
  appointmentHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  appointmentAvatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  appointmentAvatarText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
    lineHeight: 32,
  },
  patientColumnAvatar: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: 'rgba(255,255,255,0.3)',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
    textAlign: 'center',
    lineHeight: 28,
  },
  appointmentHeaderInfo: {
    flex: 1,
  },
  appointmentHeaderRight: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  patientColumnsContainer: {
    flex: 1,
  },
  patientColumn: {
    width: 200,
    backgroundColor: '#fff',
    borderRadius: 12,
    marginHorizontal: 6,
    overflow: 'hidden',
    maxHeight: '100%',
  },
  patientColumnHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
  },
  patientColumnName: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
    flex: 1,
  },
  patientColumnContent: {
    flex: 1,
    padding: 8,
  },
  pastAppointmentsCollapsed: {
    backgroundColor: '#f5f5f5',
    padding: 10,
    borderRadius: 8,
    alignItems: 'center',
    marginBottom: 8,
  },
  pastAppointmentsCollapsedText: {
    color: '#666',
    fontSize: 13,
    fontWeight: '500',
  },
  appointmentTitlePast: {
    color: '#999',
  },
  timelineContainer: {
    flex: 1,
    padding: 16,
  },
  timelineSection: {
    marginBottom: 16,
  },
  timelineSectionTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    marginBottom: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  timelineNow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 20,
    paddingVertical: 10,
    backgroundColor: '#e3f2fd',
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  timelineNowLine: {
    flex: 1,
    height: 2,
    backgroundColor: 'var(--primary)',
    marginRight: 10,
  },
  timelineNowText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'var(--primary)',
    marginRight: 8,
  },
  timelineNowTime: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'var(--primary)',
  },
  showMoreButton: {
    paddingVertical: 10,
    alignItems: 'center',
  },
  showMoreText: {
    fontSize: 14,
    color: 'var(--primary)',
    fontWeight: '500',
  },
  timelineEmpty: {
    paddingVertical: 40,
    alignItems: 'center',
  },
  timelineEmptyText: {
    fontSize: 16,
    color: '#888',
  },
  appointmentTime: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'var(--primary)',
    marginBottom: 2,
  },
  appointmentTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  appointmentPatient: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  appointmentType: {
    fontSize: 11,
    color: '#888',
    marginTop: 4,
  },
  appointmentDate: {
    fontSize: 10,
    color: 'var(--primary)',
    marginTop: 2,
    fontWeight: '600',
  },
  searchInput: {
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 8,
    marginBottom: 16,
    fontSize: 14,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  list: {
    paddingBottom: 20,
  },
  patientCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 16,
    borderRadius: 12,
    marginBottom: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  patientAvatar: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: '#1a1a2e',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  patientAvatarText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: '600',
  },
  patientInfo: {
    flex: 1,
  },
  patientName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
  },
  patientDetails: {
    fontSize: 13,
    color: '#666',
    marginTop: 2,
  },
  patientArrow: {
    fontSize: 24,
    color: '#ccc',
  },
  emptyText: {
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
    marginTop: 40,
  },
  detailContainer: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  detailHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  backButton: {
    paddingVertical: 8,
    paddingRight: 16,
  },
  backButtonText: {
    fontSize: 16,
    color: 'var(--primary)',
  },
  saveButton: {
    backgroundColor: 'var(--primary)',
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 8,
  },
  saveButtonText: {
    color: '#fff',
    fontWeight: '600',
  },
  detailProfile: {
    alignItems: 'center',
    padding: 30,
    backgroundColor: '#fff',
    marginBottom: 16,
  },
  detailAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#1a1a2e',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  detailAvatarText: {
    color: '#fff',
    fontSize: 32,
    fontWeight: '600',
  },
  detailName: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  detailField: {
    backgroundColor: '#fff',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  detailFieldLabel: {
    fontSize: 12,
    color: '#666',
    marginBottom: 6,
  },
  detailFieldValue: {
    fontSize: 16,
    color: '#333',
  },
  detailInput: {
    fontSize: 16,
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 8,
    padding: 10,
    backgroundColor: '#f9f9f9',
  },
  notesInput: {
    minHeight: 80,
    textAlignVertical: 'top',
  },
  navRow: {
    marginBottom: 20,
  },
  navArrows: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  navArrow: {
    padding: 12,
    backgroundColor: '#fff',
    borderRadius: 8,
    marginHorizontal: 8,
  },
  navArrowText: {
    fontSize: 24,
    color: '#333',
    fontWeight: 'bold',
  },
  navDate: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
    minWidth: 200,
    textAlign: 'center',
  },
  viewModeButtons: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  viewModeBtn: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    marginHorizontal: 4,
    borderRadius: 8,
  },
  viewModeBtnActive: {
    backgroundColor: '#1a1a2e',
  },
  viewModeBtnText: {
    fontSize: 14,
    color: '#666',
  },
  viewModeBtnTextActive: {
    color: '#fff',
  },
  monthGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 8,
  },
  monthWeekday: {
    width: '14.28%',
    textAlign: 'center',
    fontSize: 13,
    color: '#666',
    paddingVertical: 10,
    fontWeight: '600',
  },
  monthDay: {
    width: '14.28%',
    minHeight: 100,
    padding: 2,
  },
  monthDayBorder: {
    borderWidth: 1,
    borderColor: '#e0e0e0',
    backgroundColor: '#fff',
  },
  monthDayToday: {
    backgroundColor: '#ffebee',
    borderColor: '#e53935',
  },
  monthDaySelected: {
    backgroundColor: '#e3f2fd',
    borderColor: 'var(--primary)',
    borderWidth: 2,
  },
  monthDayHeader: {
    alignItems: 'flex-end',
    paddingRight: 4,
    paddingTop: 2,
  },
  monthDayText: {
    fontSize: 13,
    color: '#333',
  },
  monthDayTextToday: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#e53935',
  },
  monthViewContainer: {
    flex: 1,
  },
  monthAppointmentsInDay: {
    flex: 1,
    paddingHorizontal: 2,
    paddingTop: 2,
  },
  monthAppointmentBar: {
    paddingHorizontal: 3,
    paddingVertical: 2,
    borderRadius: 3,
    marginBottom: 2,
  },
  monthAppointmentPast: {
    opacity: 0.5,
  },
  monthAppointmentBarText: {
    fontSize: 8,
    color: '#fff',
    fontWeight: '500',
  },
  monthMoreText: {
    fontSize: 8,
    color: '#666',
    textAlign: 'center',
    marginTop: 2,
  },
  monthDot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: 'var(--primary)',
    marginTop: 2,
  },
  appointmentsSection: {
    backgroundColor: '#fff',
    padding: 16,
    marginTop: 16,
  },
  appointmentsTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 12,
    color: '#333',
  },
  appointmentItem: {
    flexDirection: 'row',
    padding: 12,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    marginBottom: 8,
    borderLeftWidth: 4,
  },
  appointmentItemTime: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    width: 60,
  },
  appointmentItemContent: {
    flex: 1,
  },
  appointmentItemTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  appointmentItemType: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  noAppointments: {
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
    paddingVertical: 20,
  },
  appointmentDayItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#f0f7ff',
    borderRadius: 8,
    marginBottom: 8,
    borderLeftWidth: 4,
    borderLeftColor: 'var(--secondary)',
  },
  appointmentDayDate: {
    fontSize: 15,
    fontWeight: '600',
    color: '#333',
  },
  appointmentDayCount: {
    fontSize: 14,
    color: '#666',
    fontWeight: '500',
  },
  detailRow: {
    flexDirection: 'row',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  detailLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    width: 90,
  },
  detailValue: {
    fontSize: 14,
    color: '#333',
    flex: 1,
  },
  appointmentsSectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  addAppointmentButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: 'var(--secondary)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addAppointmentButtonText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: -2,
  },
  navButtonsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addButton: {
    backgroundColor: 'var(--secondary)',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  addButtonText: {
    color: '#fff',
    fontWeight: '600',
  },
  weekDaySelected: {
    borderWidth: 2,
    borderColor: 'var(--primary)',
  },
  monthDots: {
    flexDirection: 'row',
    marginTop: 2,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    width: '80%',
    maxWidth: 400,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
  },
  modalLabel: {
    fontSize: 14,
    color: '#666',
    marginBottom: 6,
    marginTop: 12,
  },
  modalInput: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 8,
    padding: 12,
    fontSize: 16,
  },
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 24,
  },
  modalCancelButton: {
    flex: 1,
    padding: 14,
    borderRadius: 8,
    backgroundColor: '#f5f5f5',
    marginRight: 8,
    alignItems: 'center',
  },
  modalCancelText: {
    fontSize: 16,
    color: '#666',
  },
  modalSaveButton: {
    flex: 1,
    padding: 14,
    borderRadius: 8,
    backgroundColor: 'var(--primary)',
    marginLeft: 8,
    alignItems: 'center',
  },
  modalSaveText: {
    fontSize: 16,
    color: '#fff',
    fontWeight: '600',
  },
  modalSaveButtonDisabled: {
    backgroundColor: '#ccc',
  },
  modalSaveTextDisabled: {
    color: '#888',
  },
  dropdownList: {
    maxHeight: 300,
    marginBottom: 16,
  },
  dropdownItem: {
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  dropdownItemText: {
    fontSize: 16,
    color: '#333',
  },
  dropdownItemSubtext: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  dropdownText: {
    fontSize: 16,
    color: '#333',
  },
  dropdownPlaceholder: {
    fontSize: 16,
    color: '#999',
  },
  modalDeleteButton: {
    flex: 1,
    padding: 14,
    borderRadius: 8,
    backgroundColor: '#F44336',
    marginRight: 8,
    alignItems: 'center',
  },
  modalDeleteText: {
    fontSize: 16,
    color: '#fff',
    fontWeight: '600',
  },
  dayModalContent: {
    maxHeight: '80%',
  },
  dayModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  dayModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    flex: 1,
  },
  dayModalClose: {
    fontSize: 24,
    color: '#666',
    padding: 8,
  },
  dayModalList: {
    flex: 1,
  },
  dayModalItem: {
    flexDirection: 'row',
    padding: 14,
    backgroundColor: '#f9f9f9',
    borderRadius: 10,
    marginBottom: 10,
    borderLeftWidth: 4,
  },
  dayModalItemTime: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'var(--primary)',
    width: 60,
  },
  dayModalItemContent: {
    flex: 1,
  },
  dayModalItemTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
  },
  dayModalItemPatient: {
    fontSize: 14,
    color: '#666',
    marginTop: 2,
  },
  dayModalItemType: {
    fontSize: 12,
    color: '#888',
    marginTop: 2,
  },
  dayModalEmpty: {
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
    paddingVertical: 30,
  },
  monthMoreTouch: {
    paddingVertical: 2,
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 16,
    paddingVertical: 8,
  },
  checkboxLabel: {
    fontSize: 14,
    color: '#333',
    marginLeft: 12,
  },
  taskInputContainer: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  taskInput: {
    flex: 1,
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 8,
    fontSize: 14,
    borderWidth: 1,
    borderColor: '#ddd',
    marginRight: 8,
  },
  taskAddButton: {
    width: 44,
    height: 44,
    backgroundColor: 'var(--secondary)',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  taskAddButtonText: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 'bold',
  },
  taskList: {
    flex: 1,
  },
  taskItem: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 14,
    borderRadius: 8,
    marginBottom: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  taskItemCompleted: {
    opacity: 0.7,
  },
  taskCheckbox: {
    width: 22,
    height: 22,
    borderRadius: 11,
    borderWidth: 2,
    borderColor: 'var(--secondary)',
    marginRight: 12,
  },
  taskCheckboxChecked: {
    backgroundColor: 'var(--secondary)',
  },
  taskTitle: {
    flex: 1,
    fontSize: 15,
    color: '#333',
  },
  taskTitleCompleted: {
    textDecorationLine: 'line-through',
    color: '#888',
  },
  taskSectionTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#888',
    marginTop: 16,
    marginBottom: 8,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  findingsSection: {
    backgroundColor: '#fff',
    padding: 16,
    marginTop: 16,
    marginBottom: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  findingsSectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  findingsSectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  addFindingButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#9C27B0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addFindingButtonText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: -2,
  },
  findingCard: {
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#9C27B0',
  },
  findingHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  findingDate: {
    fontSize: 12,
    color: '#666',
  },
  findingType: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
    marginTop: 2,
  },
  findingExpandIcon: {
    fontSize: 12,
    color: '#666',
  },
  findingDescription: {
    fontSize: 13,
    color: '#555',
    marginTop: 10,
    lineHeight: 20,
  },
  findingDescriptionPreview: {
    fontSize: 13,
    color: '#666',
    marginTop: 6,
  },
  noFindings: {
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
    paddingVertical: 20,
  },
  findingDescriptionInput: {
    minHeight: 100,
    textAlignVertical: 'top',
  },
  findingHeaderLeft: {
    flex: 1,
  },
  findingHeaderRight: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  findingTIMessengerBadge: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: 'var(--secondary)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    marginRight: 8,
  },
  findingEditIcon: {
    fontSize: 16,
  },
});
